module.exports = __webpack_public_path__ + "static/media/orkestra.abd9af0a.jpg";